"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.argsValidator = exports.ADDRESS_REGEX = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
exports.ADDRESS_REGEX = /^0x[a-fA-F0-9]{40}$/;
const argsValidator = (abi, functionName, ...args) => {
    const functionDeclaration = Array.from(abi || []).find(({ name }) => name === functionName);
    if (!functionDeclaration) {
        console.error(`Called fn ${functionName} does not exists`, args);
        throw new Error(`Called fn ${functionName} does not exists`);
    }
    const { inputs } = functionDeclaration;
    if (Array.from(inputs).length !== args.length) {
        console.error(`Called fn ${functionName} args length is not equale`, args);
        throw new Error(`Called fn ${functionName}  args length is not equale`);
    }
    let isValid = true;
    for (const index in inputs) {
        const input = inputs[index];
        const arg = args[+index];
        switch (input.internalType) {
            case "address":
                isValid = validateAddress(arg);
                break;
            case "bool":
                isValid = typeof arg === "boolean";
                break;
            case "uint256":
                isValid = validateU256(arg);
                break;
        }
        if (!isValid) {
            console.error(`Invalid argument (${input.name}): ${arg} || fn name: ${functionName}`);
            break;
        }
    }
    return isValid;
};
exports.argsValidator = argsValidator;
const validateAddress = (address) => exports.ADDRESS_REGEX.test(address);
const validateU256 = (arg) => {
    const value = new bignumber_js_1.default(arg);
    return !value.isNaN() && value.isFinite() && value.isGreaterThanOrEqualTo(0);
};
